import React, {useState} from "react";
import {Spinner} from "react-bootstrap";
import CheckBoxBlankIcon from "./CheckBoxBlankIcon";
import CheckBoxSelectedIcon from "./CheckBoxSelectedIcon";


const planContents = (type, ahtapotFirstPackFiles,
                      ahtapotSecondPackFiles,
                      ahtapotThirdPackFiles,
                      ahtapotFourthPackFiles,
                      ahtapotFifthPackFiles,
                      ahtapotSixthPackFiles,
                      ahtapotSeventhPackFiles,ahtapotEighthPackFiles) => {
    return [
        {
            id: ahtapotFirstPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotFirstPackFiles?.fileCount}`,
            header: `${ahtapotFirstPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotFirstPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotFirstPackFiles?.discountRate} İndirim`
        },
        {
            id: ahtapotSecondPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotSecondPackFiles?.fileCount}`,
            header: `${ahtapotSecondPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotSecondPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotSecondPackFiles?.discountRate} İndirim`
        },
        {
            id: ahtapotThirdPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotThirdPackFiles?.fileCount}`,
            header: `${ahtapotThirdPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotThirdPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotThirdPackFiles?.discountRate} İndirim`
        },
        {
            id: ahtapotFourthPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotFourthPackFiles?.fileCount}`,
            header: `${ahtapotFourthPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotFourthPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotFourthPackFiles?.discountRate} İndirim`
        },
        {
            id: ahtapotFifthPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotFifthPackFiles?.fileCount}`,
            header: `${ahtapotFifthPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotFifthPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotFifthPackFiles?.discountRate} İndirim`
        },
        {
            id: ahtapotSixthPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotSixthPackFiles?.fileCount}`,
            header: `${ahtapotSixthPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotSixthPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotSixthPackFiles?.discountRate} İndirim`
        },
        {
            id: ahtapotSeventhPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotSeventhPackFiles?.fileCount}`,
            header: `${ahtapotSeventhPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotSeventhPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotSeventhPackFiles?.discountRate} İndirim`
        },
        {
            id: ahtapotEighthPackFiles.subscriptionPresalePriceId,
            enumValue: `${type}_${ahtapotEighthPackFiles?.fileCount}`,
            header: `${ahtapotEighthPackFiles?.fileCount} Adet Dosya`,
            price: ahtapotEighthPackFiles?.discountedTotalBill,
            features: [],
            outline: true,
            discount: `%${ahtapotEighthPackFiles?.discountRate} İndirim`
        },
    ]
};



const Plan = (props) => {

    const [hovered, setHovered] = useState(false);

    const hoverStyles = {
        transition: 'transform 0.3s',
        cursor: 'pointer'
    };

    const handleHover = () => {
        setHovered(true);
    };

    const handleMouseLeave = () => {
        setHovered(false);
    };

    return (
        <div x
             style={{...hoverStyles, ...(hovered && {transform: 'scale(1.09)'})}}
             onMouseEnter={handleHover}
             onMouseLeave={handleMouseLeave}
             onClick={() => props.setSelectedEnumValue(props.enumValue)}
             className={
                 props?.selectedEnumValue !== props.enumValue
                     ? "card mb-4 shadow mb-5 bg-white rounded"
                     : "card mb-4 shadow mb-5 bg-red rounded card-selected"
             }
        >
            <div
                className="card-header card-header-color d-flex align-items-center justify-content-between"
                style={{
                    color: props?.selectedEnumValue !== props.enumValue ? "black" : "black",
                    backgroundColor:
                        props?.selectedEnumValue !== props.enumValue ? "rgba(0,0,0,.05)" : "darkblue",
                }}
            >
                <h5 className="my-0 font-weight-bold text-center" style={{width:"100%"}}>{props.header}</h5>
                {props.enableCheckBoxIcon ? <div id="checkboxDiv">
                    {props?.selectedEnumValue !== props.enumValue ? <CheckBoxBlankIcon/> : <CheckBoxSelectedIcon/>}
                </div> : <></>}
            </div>

            <div className="card-body">
                <br/>
                <h4 className="card-title pricing-card-title card-title-color"
                    style={{
                        color: props?.selectedEnumValue !== props.enumValue ? "darkblue" : "gray",
                    }}>
                    {`${props?.price.toLocaleString("en-US")} TL`}</h4>
                <br/>
            </div>
            <div className="card-footer"
                 style={{
                     color: props?.selectedEnumValue !== props.enumValue ? "red" : "white",
                     backgroundColor:
                         props?.selectedEnumValue !== props.enumValue ? "rgba(0,0,0,.05)" : "darkblue",
                 }}
            >
                <h5 className="my-0 font-weight-bold">{`${props.discount}`}</h5>
            </div>
        </div>
    );
};

const AhtapotPlans = (props) => {

    if (!props.ahtapotPeriodDto) {
        return <Spinner size="lg" animation="border" role="status">
            <span className="sr-only">Loading...</span>
        </Spinner>;
    }

    const planData = planContents(
        props?.type,
        props?.ahtapotPeriodDto?.ahtapotFirstPackFiles,
        props?.ahtapotPeriodDto?.ahtapotSecondPackFiles,
        props?.ahtapotPeriodDto?.ahtapotThirdPackFiles,
        props?.ahtapotPeriodDto?.ahtapotFourthPackFiles,
        props?.ahtapotPeriodDto?.ahtapotFifthPackFiles,
        props?.ahtapotPeriodDto?.ahtapotSixthPackFiles,
        props?.ahtapotPeriodDto?.ahtapotSeventhPackFiles,
        props?.ahtapotPeriodDto?.ahtapotEighthPackFiles
    );


    const plans = planData.map((obj, i) => {
        return (
            <>
                <Plan
                    key={obj.header}
                    header={obj.header}
                    price={obj.price}
                    features={obj.features}
                    outline={obj.outline}
                    id={obj.id}
                    enumValue={obj.enumValue}
                    selectedEnumValue={props.selectedEnumValue}
                    setSelectedEnumValue={props.setSelectedEnumValue}
                    enableCheckBoxIcon={props.enableCheckBoxIcon}
                    discount={obj.discount}
                />
            </>
        );
    });

    return <div className="card-deck mb-6 text-center">{plans}</div>;
};

export default AhtapotPlans;
